// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"terms_wrapper__lg3Z9","ar":"terms_ar___BaCD","content":"terms_content__Uihdw"};